import classNames from "classnames";
import React, { HTMLAttributes } from "react";

import { StyledTable } from "./Table.styled";

export type TableProps = HTMLAttributes<HTMLTableElement> & {
  /**
   * Set rows to be having striped style
   * @default {false}
   */
  zebra?: boolean;
};

const defaultProps = {
  zebra: false
};

const Table = React.forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  const { children, className, zebra, ...restProps } = props;
  const cardClass = classNames("c-table", zebra && "c-table--zebra", className);

  return (
    <StyledTable data-testid="qa-table" ref={ref} className={cardClass} {...restProps}>
      {children}
    </StyledTable>
  );
});

Table.defaultProps = defaultProps;

export default Table;
